import {
  endpointKeys,
  PatientAggregatedActivitiesUrlParams,
  PatientLatestActivitiesUrlParams,
  CushlaGetQueryOptions,
} from '@common/api'
import {AggregatedActivity, LatestActivity} from '@common/models'
import {
  aggregatedActivitiesNormaliser,
  latestActivityNormaliser,
} from '@common/normalisers'

import {useApi, useWebGet} from './helpers'

export const useGetAggregatedActivities = (
  params: PatientAggregatedActivitiesUrlParams,
  options?: CushlaGetQueryOptions<AggregatedActivity[]>,
) =>
  useWebGet<AggregatedActivity[]>(
    [endpointKeys.patientAggregatedActivities, params],
    useApi().patientAggregatedActivities(params),
    aggregatedActivitiesNormaliser,
    {
      placeholderData: (previousData) => previousData,
      ...options,
    },
  )

export const useGetLatestActivities = (
  params: PatientLatestActivitiesUrlParams,
  options?: CushlaGetQueryOptions<LatestActivity>,
) =>
  useWebGet<LatestActivity>(
    [endpointKeys.patientLatestActivities, params],
    useApi().patientLatestActivities(params),
    latestActivityNormaliser,
    {
      placeholderData: (previousData) => previousData,
      ...options,
    },
  )
